import { EffectModel } from './EffectModel.js';

/**
 * Plugin for PIXI.Loader.
 * Usually, it is installed by {@link registerPlugins}.
 */
export class LoaderPlugin
{
    static use(resource, next)
    {
        if (resource.extension === 'js' 
            && resource.metadata
            && resource.metadata.neutrino
            && resource.data)
        {
            resource.effectModel = new EffectModel(resource.metadata.neutrino, this, resource);
        }

        next();
    }
}
